import { networkClient } from './client';
import type { ApiEnvelope } from './types';

export interface BEActiveTournament {
  id: string;
  competition_name: string | null;
  season_label: string | null;
  status: string | null;
  format: string | null;
  max_transfers: number;
  squad_size: number | null;
}

export type ActiveTournamentResponse = ApiEnvelope<BEActiveTournament>;

export const fetchActiveTournament = (): Promise<ActiveTournamentResponse> =>
  networkClient
    .get<ActiveTournamentResponse>('/api/tournament-calendars/active')
    .then(({ data }) => data);
